import { Box, Card, Typography } from '@mui/material'
import { AllocationComponent } from './AllocationComponent'

const ClaimAllocation = ({ data }) => {
  const claims = data?.claim ?? []

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          alignItems: 'center',
          borderColor: 'gray-line.main',
          p: 2,
        }}
      >
        <Typography color="light-gray-text.main" fontWeight={500}>
          Claim Allocation
        </Typography>
      </Box>

      <Box
        p={1.75}
        sx={{ borderColor: 'gray-line.main', rowGap: 3 }}
        display={'flex'}
        flexDirection={'column'}
      >
        <Card sx={{ display: 'flex', flexDirection: 'column', rowGap: 1 }} variant="none">
          <Box
            mb={2}
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Box sx={{ width: 2 / 4 }}>
              <Typography variant="body1" color="light-gray-text.main">
                Yearly Allocation
              </Typography>
            </Box>
            <Box sx={{ width: 1 / 4 }}>
              <Typography variant="body1" color="light-gray-text.main">
                Balance
              </Typography>
            </Box>
            <Box sx={{ width: 1 / 4 }}>
              <Typography variant="body1" color="light-gray-text.main">
                Allocation
              </Typography>
            </Box>
          </Box>

          {claims.length === 0 ? (
            <Typography variant="body2" color="light-gray-text.main">
              No claim allocation.
            </Typography>
          ) : (
            claims.map((item) => (
              <AllocationComponent
                key={item.id ?? item.expense_category}
                name={item.expense_category}
                item={{
                  balance: item?.entitlement?.balance ?? item?.balance ?? 0,
                  amount: item?.entitlement?.amount ?? item?.amount ?? 0,
                }}
              />
            ))
          )}
        </Card>
      </Box>
    </>
  )
}

export default ClaimAllocation
